export default __webpack_public_path__ + "static/media/cameraMobilec.1b6ac7e6.png";